import React from 'react'
import tenHairColorBanner from "./../../../../../Images/Blog/Keratin-Hair-Treatment-in-Bangalore/Banner.jpg";

const TenHairColorAllAgesImg = () => {
  return (
    <div className="blogImg-content">
      <img src={tenHairColorBanner} alt="Ten Hair Color Banner" loading="lazy" />
    </div>
  )
}

export default TenHairColorAllAgesImg
